import { Box, IconButton, Menu, MenuItem, Stack } from '@mui/material'

import { useCopyStartEndRouteConfigurationModal } from '../../../modals/CopyStartEndRouteSettingsModal'

import { useTexts } from './useTexts'
import { preview } from '@/components/form/preview'
import { Tooltip } from '@/components/primitives/Tooltip'
import { MoreHoriz } from '@mui/icons-material'
import { useCallback, useState } from 'react'

interface Props {
  singleTerritory: boolean
  startEndRouteActive: boolean
}

export function StartEndRoute(props: Props) {
  const { singleTerritory, startEndRouteActive } = props
  const texts = useTexts()

  const { show: showModal, Modal: CopyStartEndRouteConfigurationModal } =
    useCopyStartEndRouteConfigurationModal()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleMoreClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      if (singleTerritory) return

      setAnchorEl(event.currentTarget)
    },
    [singleTerritory],
  )

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  const handleCopySettingsClick = useCallback(() => {
    handleMenuClose()
    showModal()
  }, [handleMenuClose, showModal])

  return (
    <>
      <Stack direction="row" data-testid="driver-activity-start-end-route">
        <preview.Field label={texts.header.title}>
          <preview.Value>{startEndRouteActive ? texts.tracked : texts.notTracked}</preview.Value>
        </preview.Field>
        <Box marginLeft="auto" display="flex" alignItems="flex-start">
          <Tooltip title={texts.more} placement="top">
            <IconButton
              onClick={handleMoreClick}
              disabled={singleTerritory}
              data-testid="driver-activity-start-end-route_copy-btn"
              data-trackid="driver-activity-start-end-route_copy-btn"
            >
              <MoreHoriz />
            </IconButton>
          </Tooltip>
        </Box>
      </Stack>
      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        <MenuItem onClick={handleCopySettingsClick}>{texts.copySettingsToTerritory}</MenuItem>
      </Menu>
      <CopyStartEndRouteConfigurationModal />
    </>
  )
}
